var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgRoad = function SvgRoad(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 429.01C39.4 388.27 55.1 358.74 66.81 340.2C145.21 216.19 290.4 197.09 311.56 196.35C312.7 196.31 318.23 196.15 326.58 195.82C336.62 195.42 347.16 194.9 356.36 194.44",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M282.27 429.01C279.27 425.07 235.82 357.85 262.96 282.48C274.4 250.73 294.63 229.45 312.44 215.94C315.59 213.47 319.95 210.35 325.44 207.29C335.73 201.55 346.07 198.21 355.08 196.25",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M234.94 243.52C237.31 241.8 239.69 240.15 242.07 238.57",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M180.38 294.52C181.48 292.65 182.6 290.81 183.73 289.01C187.01 283.8 190.44 278.86 194 274.18",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M144.06 428.13C143.39 414.3 143.37 389.19 150.94 359.74",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M326.58 236.82L386.79 151.14L414.11 162.45L469.93 91.4102",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M376.33 166.02L263.94 112.32L247.38 139.03L224.36 103.55L214.79 125.97L125.28 67.5L103.16 103.55L78.8 78.22L29.5 121.38",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M84.54 270.35V215.95",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M84.54 241.04C103.229 241.04 118.38 225.889 118.38 207.2C118.38 188.511 103.229 173.36 84.54 173.36C65.8507 173.36 50.7 188.511 50.7 207.2C50.7 225.889 65.8507 241.04 84.54 241.04Z",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M173.57 207.37V169.21",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M173.57 186.82C186.681 186.82 197.31 176.191 197.31 163.08C197.31 149.969 186.681 139.34 173.57 139.34C160.459 139.34 149.83 149.969 149.83 163.08C149.83 176.191 160.459 186.82 173.57 186.82Z",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M398.26 431.52V324.68L370.35 294.52",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M398.26 373.97C434.965 373.97 464.72 344.215 464.72 307.51C464.72 270.805 434.965 241.05 398.26 241.05C361.555 241.05 331.8 270.805 331.8 307.51C331.8 344.215 361.555 373.97 398.26 373.97Z",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M387.11 312.63L417.08 274.18",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRoad);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/icons/road.svg";